import { render, staticRenderFns } from "./PromotionPreview.vue?vue&type=template&id=4cc89ee4"
import script from "./PromotionPreview.vue?vue&type=script&lang=js"
export * from "./PromotionPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports